import React, { forwardRef, memo } from 'react'
import * as S from './styles'
import { InputProps } from './types'
import { Icon } from '../Icon'
import { Tooltip } from '../Tooltip'

export const Input = memo(
  forwardRef<HTMLInputElement, InputProps>(
    (
      {
        id,
        label,
        type = 'text',
        dimension = 'medium',
        placeholder,
        required,
        error,
        leftIcon,
        rightIcon,
        rightElement,
        isBlock,
        hasError,
        isPill,
        disabled,
        readOnly,
        className,
        style,
        register,
        description,
        maxLength,
        priceVariant,
        errorColor = 'danger',
        ...rest
      },
      ref
    ) => (
      <S.Container isBlock={isBlock} className={className || 'class-input'} style={style}>
        {label && (
          <S.Label htmlFor={id} className='basic-input-element-label'>
            {label} {priceVariant ? <span style={{ color: '#005F7F' }}>{priceVariant}</span> : ''}
          </S.Label>
        )}
        <S.Wrapper
          dimension={dimension}
          isPill={isPill}
          hasError={hasError}
          disabled={disabled}
          readOnly={readOnly}
          leftIcon={Boolean(leftIcon)}
          rightIcon={Boolean(leftIcon) || Boolean(rightElement)}
          hasLabel={Boolean(label)}
          className='basic-input-element'
        >
          {leftIcon && <Icon name={leftIcon} />}

          <input
            ref={ref}
            type={type}
            id={id}
            required={required}
            aria-required={required}
            aria-label={label || placeholder}
            disabled={disabled}
            readOnly={readOnly}
            placeholder={placeholder}
            maxLength={maxLength}
            onWheel={(e) => e.currentTarget.blur()}
            {...rest}
            {...register}
          />

          {rightIcon && <Icon name={rightIcon} />}
          {description?.trim() && (
            <Tooltip title={description}>
              <S.Hint>
                <Icon name='info' color='#808891' />
              </S.Hint>
            </Tooltip>
          )}
          {rightElement}
        </S.Wrapper>
        {hasError && error && <S.Error $color={errorColor}>{error}</S.Error>}
      </S.Container>
    )
  )
)

Input.displayName = 'Input'
